// extracted by mini-css-extract-plugin
export default {"preloader":"Preloader_preloader__3JJGc","rotateRing":"Preloader_rotateRing__NDNwp"};